<template>
  <div>
    <el-row>
      <el-col :span="2" style="text-align: center;">
        <p v-if="!isMobile" class="logo">红&nbsp;兰&nbsp;数&nbsp;据</p>
        <el-button v-else icon="el-icon-menu" type="text"
          style="font-size: 30px;"
          @click="sideNav"
        />
      </el-col>
      <el-col v-if="!isMobile" :span="12"> 
        <el-menu 
          :default-active="activeMenu"
          mode="horizontal"
          active-text-color="#409eff"
          @select="handleNavClick"
          class="el-menu-demo"
          :collapse-transition="false"
          background-color="#fff"
          >
          <menu-item v-for="route in permission_routes" :key="route.path" 
            :item="route" :base-path="route.path" 
            style="display: inline-block;"
          />
        </el-menu>
      </el-col>
      <el-col :span="1" :offset="isMobile?6:1">
        <div v-if ="isLogin" class="popcart">
          <pop-cart />
        </div>
      </el-col>
      <el-col :span="7" style="margin: 5px; float: right;">
        <right-menu />
      </el-col>
    </el-row>

    <el-drawer
      title="目录"
      :visible.sync="showNav"
      direction = "ltr"
      :append-to-body="true"
      :modal-aapend-to-body="false"
      size="70%"
      >
      <el-menu 
        :default-active="activeMenu"
        mode="vertical"
        active-text-color="#409eff"
        @select="handleNavClick"
        class="el-menu-vertical-demo"
        :collapse-transition="false"
        background-color="#fff"
        >
        <menu-item v-for="route in permission_routes" :key="route.path" 
          :item="route" :base-path="route.path" 
        />
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import MenuItem from './MenuItem';
import PopCart from './PopCart';
import RightMenu from './RightMenu';
import ResizeMixin from '@/layout/mixin/ResizeHandler'
import { mapGetters } from 'vuex';

export default {
  mixins: [ResizeMixin],
  components:{ MenuItem, PopCart, RightMenu },
  data() {
    return {
      activePath: '',
      showNav: false,
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'isLogin',
      'isMobile'
    ]),
    activeMenu() {
      const route = this.$route
      const {meta, path} = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
  },
  created(){
    this.activePath = sessionStorage.getItem('activePath') ?
     sessionStorage.getItem("activePath") : "/home";
  },
  methods: {
    sideNav() {
      this.$nextTick(() => {this.showNav = true})
    },
    handleNavClick(activePath) {
      sessionStorage.setItem("activePath",activePath)
      this.activePath = activePath
    },
  },
}
</script>

<style lang="scss">
  .logo{
    font-size: 18px;
    color: #409EFF;
    font-weight: bolder;
    line-height: 20px;
  }
  .popcart{
    margin-top: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/layout/components/NavBar/index.vue